<%
var lic_html = '-';
if (licence) {
	const regex = /([A|Y][0-9]{8})MolSoft([0-9]{4}\.[0-9]{2}\.[0-9]{2}\. [0-9]{1,2}\:[0-9]{2}\:[0-9]{2})Informatika/gmi
	const lic = Buffer.from(licence, 'base64').toString('utf8')
	const lic_data = regex.exec(lic)

	lic_html = '<h3><div class="badge bg-danger text-light">!!! Hibás licenc kód !!!</div></h3>'

	if (lic_data) {
		const lic_ap = lic_data[1]
		if (lic_ap != ap) {
			lic_html = `<span class="text-danger">Ez a kód nem ehhez az AP számhoz tartozik! (${lic_ap})</span>`
		} else {
			const lic_ends = Anvil.moment(lic_data[2])
			const stamp = `<br /><small>${lic_ends.format('YYYY.MM.DD')} <span class="text-dim">(${lic_ends.fromNow()})</span></small>`
			if (lic_ends.isBefore()) {
				lic_html = '<span class="text-danger">Licenc lejárt</span>' + stamp
			} else if (lic_ends.isBefore(Anvil.moment().add(7, 'day'))) {
				lic_html = '<span class="text-danger">Licenc hamarosan lejár</span>' + stamp
			} else if (lic_ends.isBefore(Anvil.moment().add(1, 'month'))) {
				lic_html = '<span class="text-warning">Licenc hamarosan lejár</span>' + stamp
			} else if (lic_ends.isBefore(Anvil.moment().add(3, 'month'))) {
				lic_html = '<span class="text-primary">Licenc érvényes</span>' + stamp
			} else {
				lic_html = '<span class="text-success">Licenc érvényes</span>' + stamp
			}
		}
	}
}
%>
<div class="row">
	<div class="col-4">
		<label for="aee_licence_to_upload" class="control-label">Érvényesség</label>
	</div>
	<div class="col">
		<%- lic_html %>
	</div>
</div>